/* eslint-disable import/prefer-default-export  */
import { useTranslation as useTranslationNext } from 'react-i18next';
import packagInfo from '../package.json';

export const useTranslation = (ns = null, props = {}) => {
    const { t } = useTranslationNext(ns, props);
    return {
        t: (translationKey, defaultValue, options) => t(`${packagInfo.name}.${translationKey}`, defaultValue, options),
    };
};
